import React, { useState } from 'react';
import Spinner from '../spinner';
import './ProjectManagement.scss';

const ProjectManagement = () => {

    const [isLoading, setIsLoading] = useState(true);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <div className="project-management-wrapper">

            {isLoading && (
                <div className="monthly-overview-container is-loading">
                    <Spinner />
                </div>
            )}

            <div className="iframe-container">
                <iframe
                    src='https://peko.co.il/fincome/'
                    title="Project Management"
                    className="management-iframe"
                    onLoad={handleLoad}
                    style={{ display: isLoading ? 'none' : 'block' }}
                />
            </div>
        </div>
    );
};

export default ProjectManagement;